export const ANALYZE_ROUTE = "/login/analyze";

export const streamLineProURL = "https://grabcad.com/streamline-pro";
export const contactUsURL = "https://support.stratasys.com/en/contact-us";

export const companyTypeOptions = [
    { key: "customer", text: "Customer", value: "customer" },
    { key: "reseller", text: "Reseller", value: "reseller" },
];

export const licesneStatusOptions = [
    { key: "all", text: "All", value: "all" },
    { key: "active", text: "Active", value: "active" },
    { key: "expired", text: "Expired", value: "expired" },
    { key: "expiring", text: "Expiring", value: "expiring" },
];
